import React, { useRef, useState, useEffect, useCallback } from "react";
import html2canvas from "html2canvas";
import Cropper from "react-easy-crop";
import getCroppedImg from "./getCroppedImg";
import "./IDCard.css";
import photo from "./../../../images/avatar/1.png";
import { Spinner, Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  getCandidateById,
  updateCandidates,
} from "../../../store/actions/Candidates/candidateActions";
import { toast } from "react-toastify";
import { get, uploadFile } from "../../../services/api";
import { useSearchParams } from "react-router-dom";

const IDCard = ({ selectedCandidate, token, isView }) => {
  const cardRef = useRef();
  const [isLoading, setIsloading] = useState(false);
  const [file, setFile] = useState();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState();
  const [showCropModal, setShowCropModal] = useState(false);
  const dispatch = useDispatch();
  const [sastoken, setsastoken] = useState([]);
  const [searchParams] = useSearchParams();
  const updateCandidateId = searchParams.get("id");

  useEffect(() => {
    getSasToken();
  }, [selectedCandidate]);

  const onCropComplete = useCallback(
    async (_, croppedAreaPixels) => {
      try {
        const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
        setCroppedImage(croppedImage);
      } catch (e) {
        toast.error("Error cropping image");
      }
    },
    [imageSrc]
  );

  const handleDownload = () => {
    const card = cardRef.current;
    card.style.padding = "20px";
    card.style.backgroundColor = "#f8f9fa";
    html2canvas(card, { useCORS: true, scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.download = `${selectedCandidate?.personId || "IDCard"}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
      card.style.padding = "";
      card.style.backgroundColor = "";
    });
  };

  const onSubmit = async (e) => {
    setIsloading(true);
    e.preventDefault();
    if (croppedImage) {
      const response = await uploadFile(croppedImage, token, selectedCandidate?._id);
      if (response?.url) {
        const payload = { photo: response?.url };
        dispatch(
          updateCandidates(payload, () => {}, selectedCandidate?._id, token)
        );
        toast.success("Profile Picture saved successfully");
        dispatch(getCandidateById(updateCandidateId, token));
      } else {
        toast.error("Error uploading profile picture");
      }
    } else {
      toast.error("Please select and crop an image");
    }
    setIsloading(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setShowCropModal(true);
      };
    }
  };

  const getSasToken = async () => {
    const response = await get("/api/document/generate-sas-token", token);
    setsastoken(response?.sasToken);
  };

  return (
    <div>
      <div className="row mb-5" style={{ display: isView ? "none" : "" }}>
        <div className="col-xl-6 mb-3">
          <label className="form-label">Select File</label>
          <input
            className="form-control"
            type="file"
            onChange={handleFileChange}
          />
        </div>
        <div className="col-xl-12">
          <button className="btn btn-primary me-1" onClick={onSubmit}>
            {isLoading ? <Spinner size="sm" /> : "Update Profile Pic"}
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-start mb-3 no-print">
        <button
          className="btn btn-primary me-2"
          onClick={handleDownload}
          style={{ display: isView ? "none" : "" }}
        >
          Download ID Card
        </button>
      </div>
      <div className="id-card-wrapper">
        <div className="id-card" ref={cardRef}>
          <div className="id-card-content">
            <div className="id-card-photo-wrapper">
              <img
                src={
                  selectedCandidate?.photo
                    ? `${selectedCandidate?.photo}?${sastoken}`
                    : photo
                }
                alt="Profile"
                className="id-card-photo"
              />
            </div>
            <div className="id-card-details">
              <h2 className="id-card-name">
                {selectedCandidate?.firstName} {selectedCandidate?.lastName}
              </h2>
              <p className="id-card-id">
                <strong>ID:</strong> {selectedCandidate?.personId}
              </p>
              <p className="id-card-mobile no-print">
                <strong>Mobile:</strong>{" "}
                {selectedCandidate?.contact?.phoneNumber || ""}
              </p>
              <div className="id-card-signature-box">
                <p className="id-card-signature-label">
                  <strong>Signature:</strong>
                </p>
                <div className="id-card-signature">
                  <span className="id-card-signature-placeholder"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cropper Modal */}
      <Modal
        show={showCropModal}
        onHide={() => setShowCropModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%", height: "400px", position: "relative" }}>
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={1}
              style={{ height: "200px" }}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCropModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => setShowCropModal(false)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IDCard;
